import {
  Divider,
  Popover,
  Segmented,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
import { useUnit } from 'effector-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import ContainerInner from '../../components/ContentContainer/ContainerInner.jsx';
import {
  $mgpMaps,
  $mgpPageFiltered,
  $mgpTypeFilter,
  $mgpTypesCount,
  getMGPPageListFx,
  MGPsListGate,
  setMgpTypeFilterEv,
} from '../../models/mgpModel/index.js';
import { $activitiesMap, $regionsMap } from '../../models/globalModel/index.js';
import MGPFilters from './components/MGPFilters.jsx';
import styles from './MGPRegistry.module.css';
import NmpRegistry from './NMPRegistry.jsx';
import MgpContents from './components/MGPContents.jsx';

export default function MGPRegistry() {
  const [tab, setTab] = useState(0);
  const segmentedOptions = [
    {
      label: 'Единый перечень мер поддержки',
      value: 0,
    },
    {
      label: 'Реестр получателей мер поддержки',
      value: 1,
    },
  ];

  return (
    <ContainerInner
      title="Подбор мер поддержки"
      extra={
        <Segmented options={segmentedOptions} value={tab} onChange={setTab} />
      }
    >
      {tab === 0 ? <MgpContents /> : <NmpRegistry />}
    </ContainerInner>
  );
}
